/**
 * Filtered OneDrive documents slice (RTK). Root key: FilteredOneDriveDocuments.
 * Listens to oneDriveList fetchOneDriveDocuments.fulfilled and legacy string actions.
 */
import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_ONEDRIVE_SEARCH_RESULT_COUNT,
  DEFAULT_SELECTED_PAGE_INDEX,
} from "../../constants/metaData";
import { fetchOneDriveDocuments } from "./oneDriveListSlice";

const extractValue = (payload) =>
  payload !== null && payload !== ""
    ? payload.value !== null
      ? payload.value
      : []
    : [];

const initialState = {
  "@odata.context": null,
  value: [],
  oneDriveSearchResultCount: DEFAULT_ONEDRIVE_SEARCH_RESULT_COUNT,
  selectedPageIndex: DEFAULT_SELECTED_PAGE_INDEX,
};

const filteredOneDriveSlice = createSlice({
  name: "filteredOneDriveDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOneDriveDocuments.fulfilled, (state, action) => {
        const payload = action.payload;
        state.value = payload?.firstPage ?? [];
        state.oneDriveSearchResultCount =
          payload?.totalCount ?? (payload?.value?.length ?? 0);
      })
      .addCase("ONEDRIVE_SEARCH_Filtered", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("SET_INITIAL_VALUE", (state) => {
        state.value = [];
        state.oneDriveSearchResultCount = -1;
      })
      .addCase("ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE", (state, action) => {
        const payload = action.payload;
        state.oneDriveSearchResultCount =
          payload !== ""
            ? payload.value !== null
              ? payload.value.length
              : 0
            : 0;
      })
      .addCase("ON_PAGE_CHANGE", (state, action) => {
        state.value = action.payload;
      })
      .addCase("ON_SET_DOCUMENT_INITIAL_STATE", (state, action) => {
        state.value = action.payload;
        state.oneDriveSearchResultCount = 0;
        state.selectedPageIndex = 0;
      });
  },
});

export default filteredOneDriveSlice;
